import { render, staticRenderFns } from "./sjcj.vue?vue&type=template&id=1d069869&scoped=true&"
import script from "./sjcj.vue?vue&type=script&lang=js&"
export * from "./sjcj.vue?vue&type=script&lang=js&"
import style0 from "./sjcj.vue?vue&type=style&index=0&id=1d069869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d069869",
  null
  
)

export default component.exports